import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "mto-categories";

export const getMtoCategoriesList = async (
	currentTenantKey: string,
	filter: any = {}
) => {
	try {
		const response = await axios.get(`${url}/${currentTenantKey}/${apiURL}`, {
			params: { filter: JSON.stringify(filter) },
			...AuthHeader,
		});
		return response.data;
	} catch (error: any) {
		throw new Error(error.response.data.error);
	}
};

export const addMtoCategory = async (currentTenantKey: string, data: any) => {
	try {
		const response = await axios.post(
			`${url}/${currentTenantKey}/${apiURL}`,
			data,
			AuthHeader
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error);
	}
};

export const updateMtoCategory = async (
	currentTenantKey: string,
	_id: string,
	data: any
) => {
	try {
		const req_body = {
			filter: { _id: _id },
			data: data,
			options: { upsert: true, new: true },
		};
		const response = await axios.put(
			`${url}/${currentTenantKey}/${apiURL}`,
			req_body,
			AuthHeader
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error);
	}
};

export const deleteMtoCategory = async (
	currentTenantKey: string,
	_id: string
) => {
	try {
		const response = await axios.delete(
			`${url}/${currentTenantKey}/${apiURL}`,
			{ params: { filter: JSON.stringify({ _id: _id }) }, ...AuthHeader }
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error);
	}
};
